// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer___ePhW4","p":"p___31PKi"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/Footer/styles.scss
// module id = 279
// module chunks = 0